import {
  InsuranceReceiverType,
  InsuranceTypesType,
} from "../../Insurance/types";

export type AgingReportFormType = {
  insuranceType: InsuranceTypesType | null;
  receiver: InsuranceReceiverType | null;
  payer: InsuranceReceiverType | null;
  all: boolean;
};

export const defaultValues: AgingReportFormType = {
  insuranceType:  null,
  receiver: null,
  payer:null,
  all:false,
};
